var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_tick-circle",
    "data-name": "vuesax/outline/tick-circle",
    transform: "translate(-748 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle",
    transform: "translate(748 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.917,35.833A17.917,17.917,0,1,1,35.833,17.917,17.932,17.932,0,0,1,17.917,35.833Zm0-33.333A15.417,15.417,0,1,0,33.333,17.917,15.435,15.435,0,0,0,17.917,2.5Z",
    transform: "translate(2.083 2.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M5.963,11.946a1.249,1.249,0,0,1-.883-.367L.363,6.863A1.249,1.249,0,0,1,2.129,5.1L5.963,8.929,14.529.363A1.249,1.249,0,0,1,16.3,2.129l-9.45,9.45A1.249,1.249,0,0,1,5.963,11.946Z",
    transform: "translate(11.671 14.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H40V40H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue);
export default __webpack_public_path__ + "static/media/value.d75685cd882734f9e038f82dd374cbfb.svg";
export { ForwardRef as ReactComponent };